import FunctionalAreaTable from './FunctionalAreaTable.react'

export default FunctionalAreaTable
